(function () {
  'use strict';

  var dataPromise = null;

  function getDataUrl() {
    var scriptEl = document.querySelector('script[data-hc-data-url]');
    return scriptEl ? scriptEl.getAttribute('data-hc-data-url') : null;
  }

  function getAssetBase() {
    var scriptEl = document.querySelector('script[data-hc-asset-base]');
    return scriptEl ? scriptEl.getAttribute('data-hc-asset-base') : '';
  }

  function resolveImageUrl(image) {
    if (/^https?:\/\//.test(image) || image.indexOf('//') === 0) return image;
    return getAssetBase() + image;
  }

  function loadData() {
    if (!dataPromise) {
      var url = getDataUrl();
      dataPromise = fetch(url)
        .then(function (res) {
          return res.json();
        })
        .catch(function (err) {
          console.error('[help-center] failed to load help-center-data.json', err);
          return {};
        });
    }
    return dataPromise;
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (key) {
      if (attrs[key] === null || attrs[key] === undefined) return;
      if (key === 'class') node.className = attrs[key];
      else if (key === 'html') node.innerHTML = attrs[key];
      else node.setAttribute(key, attrs[key]);
    });
    (children || []).forEach(function (child) {
      if (child === null || child === undefined) return;
      node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    });
    return node;
  }

  function faqItem(item) {
    var details = el('details', { class: 'hc__faq-item' });
    var summary = el('summary', { class: 'hc__faq-question' }, [
      el('span', { class: 'hc__q-mark' }, ['Q.']),
    ]);
    if (item.pinned) {
      var pin = el('span', { class: 'hc__faq-pin' }, ['よくある質問']);
      summary.appendChild(pin);
    }
    summary.appendChild(document.createTextNode(item.question));
    summary.appendChild(el('span', { class: 'hc__toggle-icon' }, ['＋']));
    details.appendChild(summary);
    var answerText = item.answer || '準備中';
    var answer = el('div', {
      class: 'hc__faq-answer' + (item.answer ? '' : ' hc__faq-answer--pending'),
    }, [answerText]);
    if (item.articleHref) {
      answer.appendChild(document.createElement('br'));
      answer.appendChild(el('a', { href: item.articleHref }, ['詳しい手順を見る']));
    }
    details.appendChild(answer);
    return details;
  }

  function renderFaqList(container, items, opts) {
    opts = opts || {};
    container.innerHTML = '';
    var list = el('div', { class: 'hc__faq-list' });
    var lastGroup;
    var ordered = items;
    if (opts.groupPinFirst) {
      ordered = items.slice().sort(function (a, b) {
        var ga = a.group || '';
        var gb = b.group || '';
        if (ga !== gb) return 0;
        return (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0);
      });
    }
    ordered.forEach(function (item) {
      if (item.group && item.group !== lastGroup) {
        list.appendChild(el('div', { class: 'hc__faq-group-heading' }, [item.group]));
        lastGroup = item.group;
      }
      list.appendChild(faqItem(item));
    });
    container.appendChild(list);
  }

  function renderCategoryGrid(container, categories, currentHandle) {
    container.innerHTML = '';
    categories.forEach(function (cat) {
      var isCurrent = cat.handle === currentHandle;
      container.appendChild(
        el(
          'a',
          {
            href: isCurrent ? null : '/pages/' + cat.handle,
            class: 'hc__category-card' + (isCurrent ? ' hc__category-card--current' : ''),
          },
          [cat.label]
        )
      );
    });
  }

  function renderLinkList(container, labels, onClick) {
    container.innerHTML = '';
    labels.forEach(function (label) {
      var link = el('a', { href: '#' }, [label]);
      if (onClick) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          onClick(label);
        });
      }
      container.appendChild(link);
    });
  }

  function findFaqCategoryHandleIn(scope, questionText) {
    var categories = (scope && scope.categories) || [];
    for (var i = 0; i < categories.length; i++) {
      var handle = categories[i].handle;
      var items = (scope.categoryFaqs || {})[handle] || [];
      for (var j = 0; j < items.length; j++) {
        if (items[j].question === questionText) return handle;
      }
    }
    return null;
  }

  function findFaqCategoryHandle(data, questionText) {
    return (
      findFaqCategoryHandleIn(data.personal || {}, questionText) ||
      findFaqCategoryHandleIn(data.team || {}, questionText)
    );
  }

  function renderGuideList(container, guides) {
    container.innerHTML = '';
    guides.forEach(function (guide) {
      if (guide.href) {
        container.appendChild(el('a', { href: guide.href }, [guide.label]));
      } else {
        container.appendChild(el('span', { class: 'hc__faq-answer--pending' }, [guide.label + '（準備中）']));
      }
    });
  }

  var SEARCH_STOPWORDS = [
    'について', 'とは', 'ですか', 'でしょうか', 'ください', 'お願いします',
    '教えてください', 'を教えて', '可能ですか', 'できますか', 'こと',
    'したいです', 'したい', 'のですが', 'んですが', 'ました', 'ます',
  ];

  function stripSearchStopwords(str) {
    var out = str || '';
    SEARCH_STOPWORDS.forEach(function (w) {
      out = out.split(w).join('');
    });
    return out;
  }

  function charBigrams(str) {
    var s = (str || '').toLowerCase().replace(/[\s、。？！,.!?・「」『』【】()（）]/g, '');
    if (s.length === 0) return [];
    if (s.length === 1) return [s];
    var grams = [];
    for (var i = 0; i < s.length - 1; i++) {
      grams.push(s.slice(i, i + 2));
    }
    return grams;
  }

  function fuzzyScore(query, target) {
    var queryGrams = charBigrams(stripSearchStopwords(query));
    if (!queryGrams.length) return 0;
    var targetGrams = charBigrams(target);
    if (!targetGrams.length) return 0;
    var targetCounts = {};
    targetGrams.forEach(function (g) {
      targetCounts[g] = (targetCounts[g] || 0) + 1;
    });
    var matched = 0;
    queryGrams.forEach(function (g) {
      if (targetCounts[g] > 0) {
        matched++;
        targetCounts[g]--;
      }
    });
    return matched / queryGrams.length;
  }

  function logNoHitSearch(root, term, scope) {
    var url = root.getAttribute('data-hc-search-log-url');
    if (!url) return;
    try {
      fetch(url, {
        method: 'POST',
        keepalive: true,
        // GASのWebアプリはCORSプリフライトに対応していないため、
        // application/jsonだとnet::ERR_FAILEDになる。text/plainでプリフライトを回避する
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          term: term,
          scope: scope,
          page: window.location.pathname,
          timestamp: new Date().toISOString(),
        }),
      }).catch(function () {});
    } catch (e) {
      // ログ送信に失敗しても検索自体は継続する
    }
  }

  function wireSearch(root, getItems, onNoResults) {
    var input = root.querySelector('[data-hc-search-input]');
    var button = root.querySelector('[data-hc-search-button]');
    var chips = root.querySelectorAll('[data-hc-keyword]');
    var resultsContainer = root.querySelector('[data-hc-search-results]');
    var emptyState = root.querySelector('[data-hc-search-empty]');
    if (!input || !resultsContainer) return;

    function runSearch(term) {
      term = (term || '').trim();
      if (!term) {
        resultsContainer.hidden = true;
        if (emptyState) emptyState.style.display = 'none';
        return;
      }
      var lower = term.toLowerCase();
      var MIN_SCORE = 0.3;
      var scored = getItems()
        .map(function (item) {
          var haystack = item.question;
          var exact = haystack.toLowerCase().indexOf(lower) !== -1;
          var score = exact ? 1 : fuzzyScore(term, haystack);
          return { item: item, score: score };
        })
        .filter(function (entry) {
          return entry.score >= MIN_SCORE;
        })
        .sort(function (a, b) {
          return b.score - a.score;
        });
      var matches = scored.slice(0, 10).map(function (entry) {
        return entry.item;
      });
      resultsContainer.hidden = false;
      if (matches.length === 0) {
        resultsContainer.innerHTML = '';
        if (emptyState) emptyState.style.display = 'block';
        if (typeof onNoResults === 'function') onNoResults(term);
        return;
      }
      if (emptyState) emptyState.style.display = 'none';
      renderFaqList(resultsContainer, matches);
    }

    if (button) {
      button.addEventListener('click', function () {
        runSearch(input.value);
      });
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        runSearch(input.value);
      }
    });
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var term = chip.getAttribute('data-hc-keyword');
        input.value = term;
        runSearch(term);
      });
    });

    return runSearch;
  }

  function initTop(root, data) {
    var personal = data.personal || {};
    renderCategoryGrid(root.querySelector('[data-hc-category-grid]'), personal.categories || []);
    var faqContainer = root.querySelector('[data-hc-faq-list]');
    if (faqContainer) {
      renderFaqList(
        faqContainer,
        (personal.topFaqs || []).map(function (item) {
          return { question: item.question, answer: item.answer };
        })
      );
    }
    var guidesContainer = root.querySelector('[data-hc-guides]');
    if (guidesContainer) renderGuideList(guidesContainer, personal.guides || []);

    var allItems = [];
    Object.keys(personal.categoryFaqs || {}).forEach(function (handle) {
      (personal.categoryFaqs[handle] || []).forEach(function (item) {
        allItems.push(item);
      });
    });
    var runSearch = wireSearch(
      root,
      function () {
        return allItems;
      },
      function (term) {
        logNoHitSearch(root, term, 'personal');
      }
    );

    var popularContainer = root.querySelector('[data-hc-popular-articles]');
    if (popularContainer) {
      renderLinkList(popularContainer, personal.popularArticles || [], function (label) {
        if (!runSearch) return;
        var input = root.querySelector('[data-hc-search-input]');
        if (input) input.value = label;
        runSearch(label);
      });
    }

    var viewAllButton = root.querySelector('[data-hc-faq-viewall]');
    if (viewAllButton && faqContainer) {
      viewAllButton.addEventListener('click', function () {
        renderFaqList(faqContainer, allItems, { groupPinFirst: true });
        viewAllButton.style.display = 'none';
      });
    }
  }

  function initCategory(root, data) {
    var personal = data.personal || {};
    var handle = root.getAttribute('data-hc-category-handle');
    var category = (personal.categories || []).filter(function (c) {
      return c.handle === handle;
    })[0];
    var items = (personal.categoryFaqs || {})[handle] || [];

    var titleEl = root.querySelector('[data-hc-category-title]');
    var descEl = root.querySelector('[data-hc-category-description]');
    var countEl = root.querySelector('[data-hc-category-count]');
    if (category && titleEl) titleEl.textContent = category.label;
    if (category && descEl) descEl.textContent = category.description || '';
    if (countEl) countEl.textContent = '全' + items.length + '件';

    renderFaqList(root.querySelector('[data-hc-faq-list]'), items, { groupPinFirst: true });
    var otherCategories = (personal.categories || []).filter(function (c) {
      return c.handle !== handle;
    });
    renderCategoryGrid(root.querySelector('[data-hc-category-grid]'), otherCategories);
  }

  function renderTeamFaqList(container, items) {
    container.innerHTML = '';
    var list = el('div', { class: 'hc__faq-list' });
    items.forEach(function (item) {
      var details = el('details', { class: 'hc__faq-item' });
      var summary = el('summary', { class: 'hc__faq-question' }, [item.question]);
      summary.appendChild(el('span', { class: 'hc__toggle-icon' }, ['＋']));
      details.appendChild(summary);
      var answerText = item.answer || '準備中';
      var answer = el('div', {
        class: 'hc__faq-answer' + (item.answer ? '' : ' hc__faq-answer--pending'),
      }, [answerText]);
      if (item.articleHref) {
        var link = el('a', { href: item.articleHref }, ['詳しい手順を見る']);
        answer.appendChild(document.createElement('br'));
        answer.appendChild(link);
      }
      details.appendChild(answer);
      list.appendChild(details);
    });
    container.appendChild(list);
  }

  function renderTeamSidebar(container, categories, currentHandle) {
    container.innerHTML = '';
    categories.forEach(function (cat) {
      var isCurrent = cat.handle === currentHandle;
      container.appendChild(
        el(
          'a',
          {
            href: '/pages/' + cat.handle,
            class: isCurrent ? 'hc__sidebar-current' : null,
          },
          [cat.label]
        )
      );
    });
  }

  function initTeamTop(root, data) {
    var team = data.team || {};
    var grid = root.querySelector('[data-hc-category-grid]');
    if (grid) {
      grid.innerHTML = '';
      (team.categories || []).forEach(function (cat) {
        grid.appendChild(el('a', { href: '/pages/' + cat.handle, class: 'hc__category-card' }, [cat.label]));
      });
    }
    var groupsContainer = root.querySelector('[data-hc-team-faq-groups]');
    var allItems = [];
    if (groupsContainer) {
      groupsContainer.innerHTML = '';
      (team.categories || []).forEach(function (cat) {
        var items = (team.categoryFaqs || {})[cat.handle];
        if (!items || !items.length) return;
        items.forEach(function (item) {
          allItems.push({
            question: item.question,
            answer: item.answer,
            articleHref: item.articleHref,
            categoryLabel: cat.label,
          });
        });
        var block = el('div', { class: 'hc__section' }, [
          el('h3', { class: 'hc__section-title' }, [cat.label]),
        ]);
        var listMount = el('div');
        renderTeamFaqList(listMount, items);
        block.appendChild(listMount);
        groupsContainer.appendChild(block);
      });
    }
    wireSearch(
      root,
      function () {
        return allItems;
      },
      function (term) {
        logNoHitSearch(root, term, 'team');
      }
    );
  }

  function initTeamCategory(root, data) {
    var team = data.team || {};
    var handle = root.getAttribute('data-hc-category-handle');
    var category = (team.categories || []).filter(function (c) {
      return c.handle === handle;
    })[0];
    var items = (team.categoryFaqs || {})[handle] || [];
    var articles = (team.categoryArticles || {})[handle] || [];

    var titleEl = root.querySelector('[data-hc-category-title]');
    var countEl = root.querySelector('[data-hc-category-count]');
    if (category && titleEl) titleEl.textContent = category.label;
    if (countEl) countEl.textContent = '全' + items.length + '件';

    renderTeamFaqList(root.querySelector('[data-hc-faq-list]'), items);
    renderTeamSidebar(root.querySelector('[data-hc-sidebar]'), team.categories || [], handle);

    var articlesContainer = root.querySelector('[data-hc-related-articles]');
    if (articlesContainer) {
      articlesContainer.innerHTML = '';
      articles.forEach(function (article) {
        if (article.href) {
          articlesContainer.appendChild(el('a', { href: article.href, class: 'hc__article-card' }, [article.label]));
        } else {
          articlesContainer.appendChild(
            el('span', { class: 'hc__article-card hc__article-card--soon' }, [
              article.label,
              el('span', { class: 'hc__soon-badge' }, ['準備中']),
            ])
          );
        }
      });
    }

    var sidebarWrapper = root.querySelector('[data-hc-sidebar-wrapper]');
    var sidebarToggle = root.querySelector('[data-hc-sidebar-toggle]');
    if (sidebarWrapper && sidebarToggle) {
      sidebarToggle.addEventListener('click', function () {
        var isOpen = sidebarWrapper.classList.toggle('hc__sidebar--open');
        sidebarToggle.setAttribute('aria-expanded', String(isOpen));
      });
    }
  }

  function slugify(text, index) {
    return 'toc-' + index;
  }

  function initArticle(root, data) {
    var handle = root.getAttribute('data-hc-article-handle');
    var article = (data.articles || {})[handle];
    if (!article) return;

    var titleEls = root.querySelectorAll('[data-hc-article-title]');
    titleEls.forEach(function (n) {
      n.textContent = article.title;
    });
    var metaEl = root.querySelector('[data-hc-article-meta]');
    var leadEl = root.querySelector('[data-hc-article-lead]');
    if (metaEl) metaEl.textContent = '最終更新：' + article.updated;
    if (leadEl) leadEl.textContent = article.lead;

    var categoryLinkEl = root.querySelector('[data-hc-article-category-link]');
    if (categoryLinkEl && article.categoryHandle) {
      categoryLinkEl.textContent = article.categoryLabel || article.categoryHandle;
      categoryLinkEl.setAttribute('href', '/pages/' + article.categoryHandle);
    }

    var tocEl = root.querySelector('[data-hc-toc]');
    if (tocEl && article.toc) {
      var ol = el('ol');
      article.toc.forEach(function (heading, i) {
        ol.appendChild(el('li', {}, [el('a', { href: '#' + slugify(heading, i) }, [heading])]));
      });
      tocEl.innerHTML = '';
      tocEl.appendChild(ol);
    }

    var sectionsEl = root.querySelector('[data-hc-article-sections]');
    if (sectionsEl && article.sections) {
      sectionsEl.innerHTML = '';
      article.sections.forEach(function (section, i) {
        var sec = el('div', { class: 'hc__article-section', id: slugify(section.heading, i) }, [
          el('h2', {}, [section.heading]),
        ]);
        (section.body || []).forEach(function (p) {
          sec.appendChild(el('p', {}, [p]));
        });
        if (section.table) {
          var table = el('table', { class: 'hc__table' });
          var thead = el('tr');
          section.table.headers.forEach(function (h) {
            thead.appendChild(el('th', {}, [h]));
          });
          table.appendChild(el('thead', {}, [thead]));
          var tbody = el('tbody');
          section.table.rows.forEach(function (row) {
            var tr = el('tr');
            row.forEach(function (cell) {
              tr.appendChild(el('td', {}, [cell]));
            });
            tbody.appendChild(tr);
          });
          table.appendChild(tbody);
          sec.appendChild(table);
        }
        (section.subsections || []).forEach(function (sub) {
          var subEl = el('div', { class: 'hc__step-subsection' }, [
            el('p', { class: 'hc__step-subsection-heading' }, [sub.heading]),
          ]);
          if (sub.list && sub.list.length) {
            var listEl = el(sub.ordered ? 'ol' : 'ul');
            sub.list.forEach(function (item) {
              listEl.appendChild(el('li', {}, [item]));
            });
            subEl.appendChild(listEl);
          }
          sec.appendChild(subEl);
        });
        if (section.note) {
          sec.appendChild(
            el('div', { class: 'hc__note' }, [
              el('span', { class: 'hc__note-title' }, [section.note.title]),
              section.note.body,
            ])
          );
        }
        if (section.imagePlaceholder) {
          sec.appendChild(el('div', { class: 'hc__image-placeholder' }, ['スクリーンショット']));
        }
        sectionsEl.appendChild(sec);
      });
    }

    var relatedQEl = root.querySelector('[data-hc-related-questions]');
    if (relatedQEl) {
      var relatedQGuides = (article.relatedQuestions || []).map(function (question) {
        var handle = findFaqCategoryHandle(data, question);
        return { label: question, href: handle ? '/pages/' + handle : null };
      });
      renderGuideList(relatedQEl, relatedQGuides);
    }

    var relatedArticlesEl = root.querySelector('[data-hc-related-articles]');
    if (relatedArticlesEl) renderGuideList(relatedArticlesEl, article.relatedArticles || []);

    var ratingButtons = root.querySelectorAll('[data-hc-rating]');
    var thanksEl = root.querySelector('[data-hc-rating-thanks]');
    ratingButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (thanksEl) thanksEl.style.display = 'block';
      });
    });
  }

  function renderImage(image, alt) {
    if (typeof image === 'string') {
      return el('img', { class: 'hc__image', src: resolveImageUrl(image), alt: alt || '', loading: 'lazy' });
    }
    if (Array.isArray(image)) {
      return el(
        'div',
        { class: 'hc__image-group' },
        image.map(function (src) {
          return el('img', { class: 'hc__image', src: resolveImageUrl(src), alt: alt || '', loading: 'lazy' });
        })
      );
    }
    return el('div', { class: 'hc__image-placeholder' }, ['画像（旧ページより準備中）']);
  }

  function renderNote(note) {
    var noteEl = el('div', { class: 'hc__note' }, [el('span', { class: 'hc__note-title' }, [note.title])]);
    (note.items || []).forEach(function (item) {
      noteEl.appendChild(el('p', { style: 'margin:4px 0 0' }, [item]));
    });
    if (note.image) {
      noteEl.appendChild(renderImage(note.image, note.title));
    }
    if (note.link) {
      noteEl.appendChild(el('a', { href: note.link.href, class: 'hc__cross-link' }, [note.link.label]));
    }
    return noteEl;
  }

  function renderStep(step, index) {
    var head = el('div', { class: 'hc__step-head' }, [el('h2', { class: 'hc__step-title' }, [step.title])]);
    var stepEl = el('div', { class: 'hc__step', id: slugify(step.title, index) }, [head]);
    (step.body || []).forEach(function (p) {
      stepEl.appendChild(el('p', { class: 'hc__step-body' }, [p]));
    });
    if (step.image) {
      stepEl.appendChild(renderImage(step.image, step.title));
    }
    (step.subsections || []).forEach(function (sub) {
      var subEl = el('div', { class: 'hc__step-subsection' }, [
        el('p', { class: 'hc__step-subsection-heading' }, [sub.heading]),
      ]);
      if (sub.list && sub.list.length) {
        var ol = el('ol');
        sub.list.forEach(function (item) {
          ol.appendChild(el('li', {}, [item]));
        });
        subEl.appendChild(ol);
      }
      if (sub.image) {
        subEl.appendChild(renderImage(sub.image, sub.heading));
      }
      stepEl.appendChild(subEl);
    });
    (step.notes || []).forEach(function (note) {
      stepEl.appendChild(renderNote(note));
    });
    return stepEl;
  }

  function initOrderFlow(root, data) {
    var flowKey = root.getAttribute('data-hc-flow-key') || 'btob';
    var flow = (data.orderFlow || {})[flowKey];
    if (!flow) return;

    var titleEl = root.querySelector('[data-hc-flow-title]');
    var descEl = root.querySelector('[data-hc-flow-description]');
    if (titleEl) titleEl.textContent = flow.title;
    if (descEl) descEl.textContent = flow.description || '';

    var crossLinkEl = root.querySelector('[data-hc-cross-link]');
    if (crossLinkEl && flow.crossLink) {
      crossLinkEl.textContent = flow.crossLink.label;
      crossLinkEl.setAttribute('href', flow.crossLink.href);
      crossLinkEl.hidden = false;
    }

    var stepsEl = root.querySelector('[data-hc-steps]');
    if (stepsEl && flow.steps) {
      stepsEl.innerHTML = '';
      flow.steps.forEach(function (step, i) {
        stepsEl.appendChild(renderStep(step, i));
      });
    }

    var tocEl = root.querySelector('[data-hc-toc]');
    if (tocEl && flow.steps) {
      var ol = el('ol');
      flow.steps.forEach(function (step, i) {
        ol.appendChild(el('li', {}, [el('a', { href: '#' + slugify(step.title, i) }, [step.title])]));
      });
      tocEl.innerHTML = '';
      tocEl.appendChild(el('p', { class: 'hc__toc-title' }, ['目次']));
      tocEl.appendChild(ol);
    }

    var ratingButtons = root.querySelectorAll('[data-hc-rating]');
    var thanksEl = root.querySelector('[data-hc-rating-thanks]');
    ratingButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (thanksEl) thanksEl.style.display = 'block';
      });
    });

    var relatedQEl = root.querySelector('[data-hc-related-questions]');
    if (relatedQEl) {
      var relatedQGuides = (flow.relatedQuestions || []).map(function (question) {
        var handle = findFaqCategoryHandle(data, question);
        return { label: question, href: handle ? '/pages/' + handle : null };
      });
      renderGuideList(relatedQEl, relatedQGuides);
    }

    var relatedArticlesEl = root.querySelector('[data-hc-related-articles]');
    if (relatedArticlesEl) renderGuideList(relatedArticlesEl, flow.relatedArticles || []);
  }

  var initializers = {
    top: initTop,
    category: initCategory,
    'team-top': initTeamTop,
    'team-category': initTeamCategory,
    'team-article': initArticle,
    article: initArticle,
    'order-flow': initOrderFlow,
  };

  function init() {
    var roots = document.querySelectorAll('[data-hc-view]');
    if (!roots.length) return;
    loadData().then(function (data) {
      roots.forEach(function (root) {
        var view = root.getAttribute('data-hc-view');
        var fn = initializers[view];
        if (fn) fn(root, data);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
